import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";

export const useWithPriority = (hasPriority, heatEnded) => {
    const { id } = useParams();
    const priorityEnabled = useSelector(({ events }) =>
        events.getIn(["mini", parseInt(id)]),
    )?.get("priority_enabled");
    return hasPriority && !heatEnded && priorityEnabled;
};
